<template>
  <SingleSelect
    v-model="contractsSelected"
    searchable
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index, item}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';

export default {
  name: 'ContractFilter',
  components: {
    SingleSelect,
  },
  props: {
    label: {
      type: String,
      default: 'Contrato',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      selected: this.value.value || '',
    };
  },
  computed: {
    placeholder() {
      return this.$t('components.filters.ContractFilter.placeholder');
    },
    contractsSelected: {
      get() {
        return this.value?.value;
      },
      set(newValue) {
        if (typeof newValue !== 'string') {
          return this.$emit('input', undefined);
        }
        this.$emit('input', {
          value: newValue,
        });
      },
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
